module.exports = {
    API_KEY : "4a1fc76a90fd7469e2d84d145e3b1eab",

    // Local
    
    // API_ADMIN_URL : "http://localhost:61002/admin/",
    // API_BASE_URL : "http://localhost:61002/",
    // ASSETS_BASE_URL : "http://localhost:61002/",
    
    // Live
    API_ADMIN_URL : "https://api.complianceswebinar.com/admin/",
    API_BASE_URL : "https://api.complianceswebinar.com/",
    ASSETS_BASE_URL : "https://api.complianceswebinar.com/",
}